/**
 * the "from" and "to" properties have the string type because it might be "00", "01", "02", etc...
 */
import { ESaleAgentClientName } from '@r1-frontend/service-engineer-visit/types/ESaleAgentClientName';
import { TDeliveryOption } from '@r1-frontend/service-engineer-visit/types/TDeliveryOption';

export type THour = {
    from: string,
    to: string,
    active: boolean,
    cost?: number,
};

export type TDay = {
    day: number,
    date: string,
    weekday: string,
    hours: Record<string, THour>,
    isFirstDate: boolean,
};

export type TIncomingData = {
    dateFrom: Date,
    numberOfDays: number,
    maxNumberOfDays: number,
    contractId: number,
    clientName: ESaleAgentClientName,
    gaCategory: string,
    gaLabel?: string,
    productId?: number,
    withComment?: boolean,
}


export type TInitialState = {
    _initialized: boolean,
    _loading: boolean,
    _incomingData?: TIncomingData,
    _requestedDays: number,
    _selectedSlotAvailable: boolean | null,

    slots: Record<string, TDay>,
    errorMessage: string,
    deliveryOptions: TDeliveryOption[],

    selected: {
        date?: string,
        hour?: string,
        cost?: number,
        deliveryOption?: TDeliveryOption,
        comment: string,
    },
};

const initialState: TInitialState = {
    _initialized: false,
    _loading: true,
    _incomingData: undefined,
    _requestedDays: 0,

    _selectedSlotAvailable: null,

    slots: {},
    errorMessage: '',
    deliveryOptions: [],

    selected: {
        date: undefined,
        hour: undefined,
        cost: undefined,
        deliveryOption: undefined,
        comment: '',
    },
};

export default initialState;
